import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import * as CertificateModule from 'modules/certificate';

import * as Icon from 'components/Icon';
import Spinner from 'components/Spinner';
import Status from 'components/Status';

import Modal from 'components/Modal';
import ReportView from './ReportView';

import classes from '../../CertificateVew.module.scss';

interface IProps {
  registerId: number;
}

const ReportHistory: React.FC<IProps> = ({ registerId }) => {
  const { t } = useTranslation();

  const { data, isFetched } = useQuery({
    queryKey: ['report-history', 'list', registerId],
    queryFn: async () => {
      const { data } = await CertificateModule.Api.ReportHistory({ params: { registerId, page: 1, limit: 20 } });

      return {
        items: (data?.content || []).map(CertificateModule.Mappers.reportHistory),
        meta: CertificateModule.Mappers.meta(data?.meta)
      };
    },
    enabled: !!registerId,
    retry: false,
    keepPreviousData: true
  });

  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);

  if (!isFetched) {
    return <Spinner />;
  }

  return (
    <div className={classes.report}>
      <table className={classes.reportTable}>
        <thead>
          <tr>
            <th>{t('report_application')}</th>
            <th>{t('date_of_sending')}</th>
            <th>{t('date_of_response')}</th>
            <th>{t('status')}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {data?.items?.map(item => (
            <tr key={item.id}>
              <td>№ {item.id}</td>
              <td>{item.created_date}</td>
              <td>{item.response_date}</td>
              <td>
                {
                  {
                    IN_PROCESS: <Status variant="warning">{t('report_status_IN_PROCESS')}</Status>,
                    REJECT: <Status variant="danger">{t('report_status_REJECT')}</Status>,
                    SUCCESS: <Status variant="success">{t('report_status_SUCCESS')}</Status>
                  }[item.status]
                }
              </td>
              <td>
                {['SUCCESS', 'REJECT'].includes(item.status) && (
                  <div
                    className={classes.reportShowButton}
                    onClick={() => {
                      setSelectedId(item.id);
                      setShowViewModal(true);
                    }}
                  >
                    <Icon.System.Show width="24" height="24" />
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <Modal
        isOpen={showViewModal}
        close={() => {
          setShowViewModal(false);
        }}
        variant="white"
      >
        <ReportView id={selectedId || 0} />
      </Modal>
    </div>
  );
};

export default ReportHistory;
